module.exports = __webpack_public_path__ + "img/compare-btn.01d99f2d.svg";